<template>
  <v-footer
    class="py-4"
    dark
    height="auto"
  >
    <v-container mx-auto>
      <v-layout wrap>
        <v-flex xs9>
          <v-card-title class="maintitle">
            Subscrible us by:
          </v-card-title>
          <v-btn
            v-for="(item, i) in items"
            :key="i"
            :href="item.href"
            class="ml-0 mr-3"
            color="info"
            square
            target="_blank"
            rel="noopener"
          >
            <v-icon v-text="item.icon" />
          </v-btn>
        </v-flex>
        <v-spacer />
        <v-btn
          class="mr-0"
          square
          color="info"
          title="Go to top"
          @click="$vuetify.goTo(0)"
        >
        BackToTop
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          href: 'https://twitter.com/',
          icon: 'mdi-twitter'
        },
        {
          href: 'https://www.instagram.com/',
          icon: 'mdi-instagram'
        },
        {
          href: 'https://www.facebook.com/',
          icon: 'mdi-facebook'
        },

        {
          href: 'https://www.reddit.com/',
          icon: 'mdi-reddit'
        },
        {
          href: 'https://discordapp.com/',
          icon: 'mdi-discord'
        },
      ]
    })
  }
</script>
<style scoped>
.mr-0{
margin-top:57px;
}
.maintitle{
-moz-text-size-adjust: 100px;
}
</style>
